<template>
    <div
            v-if="isGranted('VIEW_PAYMENT_METHODS')"
            class="q-gutter-md">
        <async-items-loader :task="task" :num-items="items.length">
            No payment methods found.
        </async-items-loader>
        <q-list v-if="items.length" bordered separator>
            <payment-method-item
                    v-for="item in items"
                    :key="item.id"
                    :payment-method="item"
                    clickable>
                <q-item-section avatar>
                    <edit-payment-method-btn
                            :payment-method="item"
                            round flat
                            @updated="onUpdated(item, $event)"
                    />
                </q-item-section>
                <q-item-section avatar>
                    <delete-payment-method-btn
                            :payment-method="item"
                            round flat
                            @deleted="remove(item)"
                    />
                </q-item-section>
            </payment-method-item>
        </q-list>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import isGranted from '@/auth/isGranted';
import { PaymentMethod } from '@/type';
import AsyncItemsLoader from '@/components/item/AsyncItemsLoader.vue';
import PaymentMethodItem from './PaymentMethodItem.vue';
import EditPaymentMethodBtn from './EditPaymentMethodBtn.vue';
import DeletePaymentMethodBtn from './DeletePaymentMethodBtn.vue';
import repository from './paymentMethodRepository';

interface Data {
  items: PaymentMethod[],
  task: Promise<PaymentMethod[]>|null,
}

export default defineComponent({
  components: {
    AsyncItemsLoader,
    EditPaymentMethodBtn,
    DeletePaymentMethodBtn,
    PaymentMethodItem,
  },
  props: {
    customerId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      items: [],
      task: null,
    };
  },
  watch: {
    customerId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },

  methods: {
    load() {
      this.task = repository.findAll(this.customerId);
      this.task.then((items: PaymentMethod[]) => {
        this.items = items;
      });
    },
    push(item: PaymentMethod) {
      this.items.push(item);
    },
    remove(item: PaymentMethod) {
      const index = this.items.findIndex(i => i.id === item.id);
      if (index >= 0) {
        this.items.splice(index, 1);
      }
    },
    onUpdated(item: PaymentMethod, updated: PaymentMethod) {
      Object.assign(item, updated);
    },
    isGranted,
  },
});
</script>
